<template>
    <div>

        <!-- Header Start -->
        <div style="margin-bottom: 24px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;" class="flex-wrap">
            <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0; color: #111827;">QR Distribution Monitoring</h2>
        </div>
        <!-- Header End -->

        <!-- Distribution Overview Start -->
        <div class="bg-white rounded shadow-sm mb-4" style="padding: 20px">
            <h3 class="h5 font-weight-semibold" style="color: #2F2F2F; margin-bottom: 20px;">Distribution Overview</h3>
            <div class="row stats-row">
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/saldo-awal.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">Saldo Awal</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && data.stats.qty_before !== undefined && data.stats.qty_before !== null ? numberWithCommas(data.stats.qty_before) : '1.500' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/in-transit-dealer.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">In-Transit Dealer</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && (data.stats.qty_intransit !== undefined || data.stats.qty_dealer_intransit !== undefined) ? numberWithCommas(data.stats.qty_intransit || data.stats.qty_dealer_intransit) : '12.000' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/diterima-md.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">Diterima Dealer</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && (data.stats.qty_received !== undefined || data.stats.qty_dealer_received !== undefined) ? numberWithCommas(data.stats.qty_received || data.stats.qty_dealer_received) : '7.350' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/dikirim-ke-pos.svg" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">Dikirim ke Pos</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && data.stats.qty_sent_pos !== undefined && data.stats.qty_sent_pos !== null ? numberWithCommas(data.stats.qty_sent_pos) : '1.350' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/diterima-dealer.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">QR Dipakai</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && data.stats.qty_mapping !== undefined && data.stats.qty_mapping !== null ? numberWithCommas(data.stats.qty_mapping) : '7.350' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/saldo-akhir.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">Saldo Akhir</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && data.stats.qty_after !== undefined && data.stats.qty_after !== null ? numberWithCommas(data.stats.qty_after) : '3.000' }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Distribution Overview End -->

        <!-- Detail Pengiriman Start -->
        <deliveryDetailTable></deliveryDetailTable>
        <!-- Detail Pengiriman End -->

        <!-- Distribution Projection Start -->
        <div class="bg-white rounded shadow-sm mb-4" style="padding: 20px">
            <div class="d-flex flex-row justify-content-between align-items-center flex-wrap mb-3">
                <h3 class="h5 font-weight-semibold mb-0" style="color: #2F2F2F;">Proyeksi Distribusi</h3>
                <div class="d-flex flex-row align-items-center flex-wrap">
                    <div style="width: 170px; margin: 5px 8px;">
                        <MultiSelect
                            v-model="custom_filter.distributionProjection.year"
                            :options="options.year"
                            :allow-empty="false"
                            class="qtrust-select"
                            placeholder="Semua Tahun"
                        ></MultiSelect>
                    </div>
                    <div style="width: 170px; margin: 5px 8px;">
                        <MultiSelect
                            v-model="custom_filter.distributionProjection.kode_dealer"
                            :options="options.dealer.map(type => type.code)"
                            :custom-label="opt => {
                                const found = options.dealer.find(x => x.code == opt);
                                if (!found) return opt;
                                return found.name.length > 16 ? found.name.substring(0, 16) + '...' : found.name;
                            }"
                            class="qtrust-select"
                            placeholder="Semua Dealer"
                        ></MultiSelect>
                    </div>
                </div>
            </div>
            <distribution-projection
                :data="data.distributionProjection"
                :filter="custom_filter.distributionProjection"
            ></distribution-projection>
        </div>
        <!-- Distribution Projection End -->

        <!-- Detail Mapping QR Code Start -->
        <mapping-detail-table></mapping-detail-table>
        <!-- Detail Mapping QR Code End -->
    </div>
</template>

<script>
import moment from 'moment';

import deliveryDetailTable from './children/deliveryDetailTable.vue'
import distributionProjection from './children/distributionProjectionChart.vue'
import mappingDetailTable from './children/mappingDetailTable.vue'

export default {
    metaInfo : {
        title : 'Distribution Monitoring'
    },
    data () {
        return {
            moment: moment,
            options : {
                year : [...new Set(Array.from({length:5}, (_,i)=>Math.max(parseInt(moment().format('YYYY'))-i, 2024)))],
                karesidenan : this.$store.getters.getKaresidenan,
                dealer : this.$store.getters.getDealer(),
            },
            custom_filter : {
                distributionProjection : {
                    year: 2024,
                    kode_dealer: null,
                }
            },
            data : {
                stats : null,
                distributionProjection : null,
            }
        }
    },
    components : {
        deliveryDetailTable,
        distributionProjection,
        mappingDetailTable,
    },
    beforeMount () {
        const contentEl = document.getElementById('content');
        if (contentEl) {
            contentEl.style.background = '#F8F8F8';
        }
    },
    beforeDestroy () {
        const contentEl = document.getElementById('content');
        if (contentEl) {
            contentEl.style.background = '';
        }
    },
    mounted () {
        this.fetchData();
    },
    watch : {
        'custom_filter.distributionProjection' : {
            deep: true,
            handler() {
                this.fetchData('distributionProjection');
            },
        }
    },
    methods : {
        fetchData(module) {
            // Stats Overview
            if (module == 'stats' || module == null) {
                this.$http.get(`/api/qrs/highlight/dealer`)
                .then((resp)=>{
                    this.data.stats = resp.data.data;
                })
                .catch((err)=>{
                    console.log(err);
                });
            }

            // Distribution Projection
            if (module == 'distributionProjection' || module == null) {
                this.$http.get(`/api/qrs/forecast/dealer`, {params: this.custom_filter.distributionProjection})
                .then((resp)=>{
                    let data = resp.data.data;
                    if (!data || Object.keys(data).length === 0) {
                        this.data.distributionProjection = null;
                        return;
                    }
                    const result = [];
                    const currentDate = moment();

                    // Convert the input data keys to an array of dates
                    const dates = Object.keys(data).map(date => moment(date, "YYYY-MM"));

                    // Iterate over each date to construct the output                
                    dates.forEach((date) => {
                        let entry = {
                            date: date.toDate(),
                        };

                        if (date.isBefore(currentDate, 'month')) {
                            entry.pengeluaran = data[date.format("YYYY-MM")].mapping;
                            entry.pemesanan = data[date.format("YYYY-MM")].receipt;
                        } else if (date.isSame(currentDate, 'month')) {
                            entry.pengeluaran = data[date.format("YYYY-MM")].mapping;
                            entry.pemesanan = data[date.format("YYYY-MM")].receipt;
                            entry.projection = data[date.format("YYYY-MM")].receipt;
                        } else {
                            entry.projection = data[date.format("YYYY-MM")].receipt;
                        }

                        result.push(entry);
                    });

                    this.data.distributionProjection = result;
                })
                .catch((err)=>{
                    console.log(err);
                    this.data.distributionProjection = null;
                });
            }
        },
    }
}
</script>

<style>
    .qtrust-select {
        min-height: 0;
    }

    .qtrust-select .multiselect__tags {
        min-height: 0;
        height: 32px;
        padding: 4px 40px 0 8px;
        border-color: #E2E8F0;
        border-radius: 4px;
    }

    .qtrust-select .multiselect__tags .multiselect__placeholder {
        margin: 0;
        padding: 0;
        font-size: 13px;
        color: #374151;
    }

    .qtrust-select .multiselect__select {
        height: 32px;
        padding: 4px 8px;
    }

    .qtrust-select .multiselect__select::before {
        z-index: 1;
        margin: 0;
        border-color: #9CA3AF transparent transparent;
    }

    .qtrust-select .multiselect__single {
        margin: 0;
        font-size: 13px;
        color: #111827;
    }
</style>

<style scoped>
    .stats-row {
        padding: 10px 0 5px;
    }
    .stats-row .col-md:not(:first-child) {
        border-left: 1px solid #ECECEC;
    }
</style>